import classNames               from 'classnames';
import * as React               from 'react';
import { useTranslation }       from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import { LocalStorageService }  from 'ts-storage-service';

import './scss/style.scss';

import deleteCookiesBasedOnPreferences from '../../common/tools/deleteCookiesBasedOnPreferences';
import notifyCookieConsentChanged      from '../../common/tools/notifyCookieConsentChanged';
import { useCommon }                   from '../../providers/common';

import RenderButton from '../buttons/base/RenderButton';
import CloseIcon    from '../icons/CloseIcon';

const CookieNotice = () => {
  const location = useLocation();
  const { t }    = useTranslation();

  const common = useCommon();

  const ls = new LocalStorageService('cookie');

  const [accept, setAccept] = React.useState(true);

  const handleClick = React.useCallback((isAccept = false) => {
    const currentDate    = new Date();
    const oneYearFromNow = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));

    setAccept(true);

    if (isAccept) {
      ls.setData('settings', {
        technical_cookie:  true,
        analytical_cookie: true,
        marketing_cookie:  true,
      }, oneYearFromNow);
    } else {
      ls.setData('settings', {
        technical_cookie:  true,
        analytical_cookie: false,
        marketing_cookie:  false,
      }, oneYearFromNow);
      deleteCookiesBasedOnPreferences();
    }
    ls.setData('accept', true, oneYearFromNow);
    notifyCookieConsentChanged();
  }, [deleteCookiesBasedOnPreferences, ls]);

  React.useEffect(() => {
    setAccept(ls.getData('accept'));
  }, [ls.getData('accept')]);
  React.useEffect(() => {
    if (accept) {
      deleteCookiesBasedOnPreferences();
    }
  }, [location.pathname]);

  return (
    <>
      {!accept && (<div className={'cookie_notice'}>
      <span
        className={'close_btn'}
        onClick={() => setAccept(true)}
      >
        <CloseIcon />
      </span>
        <div className={'cookie_container'}>
          <div className={'cookie_wrapper'}>
            <h2>{t('cookies_notice.cookies_title')}</h2>
            <p>{t('cookies_notice.cookies_description')}</p>
          </div>
          <div className={'btn_wrapper'}>
            <NavLink
              className={classNames('btn', 'primary')}
              to={common.getUrlByTemplate('cookie-settings')}
              onClick={() => setAccept(true)}
            >{t('btn_setting')}
            </NavLink>
            <RenderButton
              action={() => handleClick(false)}
              className={classNames('btn', 'primary')}
              label={t('btn_decline')}
            />
            <RenderButton
              action={() => handleClick(true)}
              className={classNames('btn', 'fill')}
              label={t('btn_accept_everything')}
            />
          </div>
        </div>
      </div>)}
    </>
  );
};

export default CookieNotice;